<template>
	<div>
		<div class="view_inner">
			<table class="view_tbl">
				<colgroup>
					<col style="width:100px;" />
					<col style="" />
				</colgroup>
				<tbody>
					<tr v-if="session_user.admin_yn == 'N'">
						<th>Old Password</th>
						<td><input type="password" v-model.trim="old_password" class="tbl_int sm_int" /></td>
					</tr>
					<tr>
						<th>New Password</th>
						<td><input type="password" v-model.trim="new_password" class="tbl_int sm_int" /></td>
					</tr>
					<tr>
						<th>Confirm</th>
						<td><input type="password" v-model.trim="new_password_confirm" class="tbl_int sm_int" /></td>
					</tr>
				</tbody>
			</table>

			<br />

			<div class="view_bottom_bt">
				<a href="javascript:;" id="save" type="button" class="search_bt" @click="changePassword()">Save & Close</a>
				<a href="javascript:;" id="save" type="button" class="gray_bt" @click="close(false)">Cancel</a>
			</div>
		</div>
	</div>
</template>

<script>
import { apiChangePassword } from '@/api/basicinfo/user.js';
// import { errorToastAndReturn } from '@/utils/toast.js';

export default {
	data: function() {
		return {
			old_password: '',
			new_password: '',
			new_password_confirm: '',

			session_user: {},
		};
	},
	props: {
		user_id: null,
	},
	methods: {
		errorToastAndReturn(msg) {
			this.$toast.error(msg);
			return false;
		},
		isValid() {
			if (this.session_user.admin_yn == 'N' && !this.old_password) return this.errorToastAndReturn('Old password is empty');
			if (!this.new_password || !this.new_password_confirm) return this.errorToastAndReturn('New password is empty');
			if (this.new_password != this.new_password_confirm) return this.errorToastAndReturn('New passwords are different');

			return true;
		},
		async changePassword() {
			// if (!this.old_password) {
			// 	this.$toast.error('Old password is empty');
			// 	return;
			// }
			// if (!this.new_password || !this.new_password_confirm) {
			// 	this.$toast.error('New password is empty');
			// 	return;
			// }

			// if (this.new_password != this.new_password_confirm) {
			// 	this.$toast.error('New passwords are different');
			// 	return;
			// }
			if (!this.isValid()) return;

			const { data } = await apiChangePassword({
				user_id: this.user_id,
				old_password: this.old_password,
				new_password: this.new_password,
			});
			//console.log(data);

			//console.log(this.user.name);
			if (data.result) {
				this.$toast.success('Password changed successfully');
				this.close(true, this.new_password);
			} else {
				this.$toast.error(data.msg);
			}
		},
		close(returnValue, newPassword) {
			//console.log('cancel');
			this.$emit('close', returnValue, newPassword);
		},
	},
	created() {
		//console.log(this.user_id);
		this.session_user = this.$session.get('user');
	},
};
</script>

<style></style>
